export const UPDATE_API_URL =
  "https://api.betbond.app/api/app/android/update";

export const FALLBACK_APK_URL =
  "https://api.betbond.app/downloads/betbond-latest.apk";

export const OFFICIAL_DOWNLOAD_PAGE_URL = "https://betbond.app/download";

export const ANDROID_PACKAGE_ID = "com.betbond";

export function formatApkSize(bytes) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value <= 0) return null;
  if (value >= 1024 * 1024) {
    return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  }
  return `${Math.round(value / 1024)} KB`;
}

export function formatReleaseDate(iso) {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function shortenSha256(hash) {
  const value = String(hash || "");
  if (value.length < 16) return value;
  return `${value.slice(0, 8)}…${value.slice(-8)}`;
}

export function buildQrCodeUrl(targetUrl) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=${encodeURIComponent(
    targetUrl
  )}`;
}
